import { Component, Input, OnInit } from "@angular/core";
import { SessionService } from "../../../app/common/services/session.service";

import { ScheduleBookChartService } from "../services/api/schedule-book-chart.service";

@Component({
  selector: "app-schedule-book-chart",
  templateUrl: "./schedule-book-chart.component.html",
  styleUrls: ["./schedule-book-chart.component.scss"],
})
export class ScheduleBookChartComponent implements OnInit {
  chartData: any;
  @Input()
  set shceduleChartData(value) {
    this.chartData = value;
  }
  get shceduleChartData() {
    return this.chartData;
  }

  officeData: any;
  scheduleBookChart: any;
  options: any;
  chartColors = [
    "rgba(95, 227, 161, 1)",
    "rgba(255, 131, 115, 1)",
    "rgba(255, 218, 131, 1)",
    "rgba(252, 166, 215, 1)",
    "rgba(163, 166, 180, 1)",
    "rgba(255, 181, 69, 1)",
    "rgba(86, 217, 254, 1)",
    "rgba(163, 161, 251, 1)",
    "rgba(228, 151, 117, 1)",
    "rgba(255, 0, 0, 0.6)",
    "rgba(101, 246, 183, 1)",
    "rgba(246, 110, 101, 1)",
    "rgba(246, 101, 244, 1)",
    "rgba(202, 242, 225, 1)",
    "rgba(242, 217, 202, 1)",
    "rgba(217, 202, 242, 1)",
    "rgba(149, 108, 218, 1)",
    "rgba(218, 108, 108, 1)",
    "rgba(196, 108, 218, 1)",
    "rgba(229, 254, 210, 0.9)",
    "rgba(0, 255, 230, 1)",
    "rgba(176, 178, 252, 1)",
    "rgba(68, 71, 248, 1)",
  ];

  constructor(
    private chartAPI: ScheduleBookChartService,
    private readonly session: SessionService
  ) {
    this.options = {
      title: {
        display: false,
        text: "My Title",
        fontSize: 16,
      },
      legend: {
        position: "bottom",
        display: false,
      },
      cutoutPercentage: 80, //Here for innerRadius. It's already exists
      outerRadius: 100, //Here for outerRadius
    };
  }

  getScheduleBookData() {
    let temp = [];
    temp[0] = this.chartData;

    this.scheduleBookChart = {
      labels: [],
      datasets: [
        {
          label: "Schedule",
          data: [],
          backgroundColor: [] = this.chartColors,
        },
      ],
    };

    temp[0].filter((ele) => {
      this.scheduleBookChart.datasets[0].data.push(JSON.parse(ele.count));
      this.scheduleBookChart.datasets[0].data.sort((a, b) => {
        return a - b;
      });
      this.scheduleBookChart.labels.push(ele.attended);
    });
    this.scheduleBookChart[
      "Total"
    ] = this.scheduleBookChart.datasets[0].data.reduce(
      (total, curr) => total + curr,
      0
    );
  }

  ngOnInit() {
    this.officeData = this.session.getOffice();
    setTimeout(() => {
      this.getScheduleBookData();
    });
  }
}
